import { PermissionsEnum } from "@/auth/interfaces";
import { a11yProps, EstadoPreventaEnum, sizeTab, useCheckPermissionsArray } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import TablePreventaGestionVentaPymes from "../../shared/table_preventa_gestion_venta_pymes/TablePreventaGestionVentaPymes";
import TablePreagendamientoGestionVenta from "../../shared/table_preagendamiento_gestion_venta/TablePreagendamientoGestionVenta";

export default function GestorVentaPymesPage() {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_preagendamientopymes,
  ]);
  
  const [valueTab, setValueTab] = useState(0);
  return (
    <SingleTableBoxScene
      title={"Gestión Ventas PYMES"}
      py={2}

      visibleReport={false}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Preventa'} {...a11yProps(0)} />
          <Tab label={'Preagendamiento'} {...a11yProps(1)} />
          {/* <Tab label={'Agendamiento'} {...a11yProps(1)} /> */}
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TablePreventaGestionVentaPymes
          estado_preventa={EstadoPreventaEnum.PRE_RECHAZADO}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TablePreagendamientoGestionVenta
        />
      </CustomTabPanel>
      {/* <CustomTabPanel value={valueTab} index={2}>
        <PreRechazoAgendamientoVenta
          es_pyme={true}
        />
      </CustomTabPanel> */}

    </SingleTableBoxScene >
  );

}